"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicHead = exports.StaticHead = exports.initHeadManager = exports.DATA_DYNAMIC_HEAD = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const reduce_head_1 = require("./reduce-head");
const head_side_effect_1 = require("./head-side-effect");
const head_manager_1 = require("./head-manager");
exports.DATA_DYNAMIC_HEAD = 'data-dynamic';
const initHeadManager = () => {
    window.headManager = (0, head_manager_1.createHeadManager)();
};
exports.initHeadManager = initHeadManager;
const StaticHead = (props) => {
    const { children } = props;
    if (__BUILD_VARIANT__ === 'default') {
        return children;
    }
    if (__BUILD_TARGET__ === 'server') {
        return children;
    }
    return null;
};
exports.StaticHead = StaticHead;
const DynamicHead = (props) => {
    const { children } = props;
    if (__BUILD_VARIANT__ === 'default') {
        return children;
    }
    if (__BUILD_TARGET__ === 'server') {
        const components = (0, reduce_head_1.reduceComponents)(react_1.Children.toArray(children));
        return components;
    }
    return ((0, jsx_runtime_1.jsx)(head_side_effect_1.HeadSideEffect, { reduceComponentsToState: reduce_head_1.reduceComponents, headManager: window.headManager, children: children }));
};
exports.DynamicHead = DynamicHead;
